import { createCrudApi } from '../createCrudApi';

export type ParameterResult = {
  id: number;
  is_out_of_range: string;
  parameter_name: string;
  parameter_abbreviation: string;
  parameter_units: string;
  result_type: 'QUANTITATIVE' | 'QUALITATIVE' | 'TEXT' | 'COMMENT';
  effective_lower_limit: string | null;
  effective_upper_limit: string | null;
  external_id: string | null;
  value: string | null;
  text_value: string | null;
  rich_text_value: string | null;
  comment_value: string | null;
  sampling: number;
  parameter_definition: number | null;
};

export type Sampling = {
  id: number;
  external_id: string | null;
  made_at: string;
  deceased: number;
  parameter_results: ParameterResult[];
};

export type LaboratoryArea = {
  id: number;
  name: string;
  external_id: string | null;
  description: string;
};

export type ParameterDefinition = {
  id: number;
  name: string;
  abbreviation: string;
  units: string;
  area: number | null;
  area_name: string;
  lower_limit: string | null;
  upper_limit: string | null;
};

export type SamplingsGetParams = {
  deceased?: number;
  made_at__gte?: string;
  made_at__lte?: string;
  limit?: number;
  offset?: number;
};

export type ParameterDefinitionsGetParams = {
  area?: number;
  limit?: number;
  offset?: number;
};

export const ComplementApi = () => ({
  samplings: createCrudApi<Sampling, never, SamplingsGetParams>('/v1/complement/samplings/'),
  parameterDefinitions: createCrudApi<ParameterDefinition, never, ParameterDefinitionsGetParams>(
    '/v1/complement/parameter-definitions/'
  ),
  laboratoryAreas: createCrudApi<LaboratoryArea, never, Record<string, unknown>>(
    '/v1/complement/laboratory-areas/'
  ),
});
